
import { put, takeEvery } from "redux-saga/effects";

import { AUTH_RENEW_SESSION, AuthRenewSessionAction, logout, setToken } from "../actions";
import { getStoredCredentials } from "../util";
import { refreshAccessToken, RefreshTokenReturn } from "./WebAuth";

export function* renewSession(action: AuthRenewSessionAction) {
    const currentCreds = getStoredCredentials();
    if (currentCreds && currentCreds.refreshToken) {
        try {
            const sessionResult: RefreshTokenReturn = yield refreshAccessToken({ refreshToken: currentCreds.refreshToken });

            yield put(setToken({
                accessToken: sessionResult.access_token,
                expiresInSeconds: sessionResult.expires_in,
                refreshToken: sessionResult.refresh_token
            }));
        } catch (error) {
            // The refresh token is no longer good, so the session really is over.  Logging out
            // sends the user to /login carrying the path they asked for, rather than leaving
            // whoever is waiting on the renewal stuck on a spinner.
            yield put(logout());
        }
    }
}

export function* watchRenewSession() {
    yield takeEvery(AUTH_RENEW_SESSION, renewSession);
}
